export const loadedSongs = [
  {
    value: "firststep.mid",
    name: "Interstellar",
  },
  {
    value: "yiruma.mid",
    name: "Yiruma",
  },
  {
    value: "Moonlight Sonate.mid",
    name: "Moonlight Sonate",
  },
  {
    value: "Tschaikowsky.mid",
    name: "Tschaikowsky",
  },
  {
    value: "love.mid",
    name: "Where's my Love",
  },
];
